import {
  GET_WEEKLY_EMAIL_SETTINGS,
  UPDATE_WEEKLY_EMAIL_SETTINGS,
  UPDATE_LOCATION_SETTINGS,
  UPDATE_GEOFENCE_SETTINGS,

  GET_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS,
} from "../../modules/constants";

// ------------------------------------
// Weekly Email Actions
// ------------------------------------
export function getWeeklyEmailSettings(value) {
  return {
    type: GET_WEEKLY_EMAIL_SETTINGS,
    payload: value,
  };
}

export function updateWeeklyEmailSettings(value) {
  return {
    type: UPDATE_WEEKLY_EMAIL_SETTINGS,
    payload: value,
  };
}

// ------------------------------------
// Notification Actions
// ------------------------------------
export function getNotificationSettings(value) {
  return {
    type: GET_NOTIFICATION_SETTINGS,
    payload: value,
  };
}

export function updateNotificationSettings(value) {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS,
    payload: value,
  };
}

// ------------------------------------
// Location & Geofence Actions
// ------------------------------------
export function updateLocationSettings(value) {
  return {
    type: UPDATE_LOCATION_SETTINGS,
    payload: value,
  };
}

export function updateGeofenceSettings(value) {
  return {
    type: UPDATE_GEOFENCE_SETTINGS,
    payload: value,
  };
}
